<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <form [formGroup]="tenant_form" novalidate>
    <div class="p-7 space-y-5">
      <div class="flex items-start justify-between mb-4">
        <div class="flex items-start gap-2.5">
          <div
            class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
          >
            <igntr-icon name="info"></igntr-icon>
          </div>
          <div>
            <div class="text-[14px] font-semibold !text-slate-900">
              {{ "info" | transloco }}
            </div>
            <div class="text-[12px] !text-slate-500 mt-0.5">
              {{ "coreTenantIdentity" | transloco }}
            </div>
          </div>
        </div>
        <button
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium"
          (click)="onSubmit()"
          [disabled]="!tenant_form.valid"
        >
          {{ "save" | transloco }}
        </button>
      </div>
      <div class="rounded-xl border !border-slate-200/70 bg-white">
        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <!-- <app-blob-file-uploader
          (FileSubmit)="updateFile($event)"
          (delete)="deleteLogo()"
          class="w-100 p-0"
          placeholder="{{ 'selectImage' | transloco }}"
          [fileType]="'image/*'"
          [fileTypeValidationString]="'image'"
          [showDefaultDelete]="true"
          [selectedFileNames]="blobService.getFileName(tenant_form.value.image)"
          [withCompression]="true"
          (compressImagesSubmit)="changeHasCompressedImage($event)"
        ></app-blob-file-uploader> -->
          <div class="w-100">
            <div class="text-[14px] font-medium !text-slate-700">
              {{ "desktop" | transloco }} {{ "logo" | transloco }}
            </div>
            <app-media-library-drop-zone
              [mediaLibraryFiles]="[logoMediaLibraryFile]"
              [allowImagesSelection]="true"
              [showOnlyPrivateFiles]="true"
              (onFileSelected)="onLogoMediaLibraryFileSelected($event)"
              (onFileRemoved)="removeImage()"
            ></app-media-library-drop-zone>
          </div>
          <!-- <app-media-library-multiple-files-selector
          class="p-0"
          [mediaLibraryFiles]="[tenant_form.get('image')?.value]"
          [allowImagesSelection]="true"
          (onFileSelected)="tenant_form.get('image')?.setValue($event[0])"
          (onFileRemoved)="tenant_form.get('image')?.setValue(null)"
        /> -->
        </div>

        <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <input
            formControlName="headline"
            type="text"
            class="w-full text-[14px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            placeholder="{{ 'headline' | transloco }}"
          />
        </div>

        <!-- <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <textarea
            rows="3"
            id="editor"
            type="text"
            placeholder="{{ 'pageHtml' | transloco }}"
            autocomplete="off"
            formControlName="pageHtml"
            class="w-full text-[12.5px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 resize-none"
          >
          </textarea>
        </div> -->
        <div class="form-floating px-3.5 py-3">
          <p-editor
            class="editor"
            [style]="{ minHeight: '80px' }"
            placeholder="{{ 'pageHtml' | transloco }}"
            formControlName="pageHtml"
          >
            <ng-template pTemplate="header">
              <app-editor loadData [tenant]="tenant"></app-editor
            ></ng-template>
          </p-editor>
        </div>
        <div
          class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0"
          [appValidateState]="tenant_form.get('videoUrl')"
        >
          <input
            formControlName="videoUrl"
            type="text"
            class="w-full text-[14px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400"
            placeholder="{{ 'VideoUrl' | transloco }}"
            i18n-placeholder="Url placeholder @@url"
          />
          <small
            class="text-danger"
            *ngIf="tenant_form.get('videoUrl')?.hasError('pattern')"
          >
            {{ "unsafeUrl" | transloco }}
          </small>
        </div>

        <!-- <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <textarea
            id="editor2"
            type="text"
            placeholder="{{ 'pageHtml2' | transloco }}"
            autocomplete="off"
            formControlName="pageHtml2"
            class="w-full text-[12.5px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 resize-none"
          >
          </textarea>
        </div> -->

        <div class="form-floating px-3.5 py-3">
          <p-editor
            class="editor"
            placeholder="{{ 'pageHtml2' | transloco }}"
            [style]="{ minHeight: '80px' }"
            formControlName="pageHtml2"
          >
            <ng-template pTemplate="header">
              <app-editor loadData [tenant]="tenant"></app-editor
            ></ng-template>
          </p-editor>
        </div>

        <!-- <div class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0">
          <textarea
            id="editor3"
            type="text"
            placeholder="{{ 'mobile' | transloco }} {{
              'description' | transloco
            }}"
            autocomplete="off"
            formControlName="descriptionMobile"
            class="w-full text-[12.5px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 resize-none"
          >
          </textarea>
        </div> -->
        <div class="form-floating px-3.5 py-3">
          <p-editor
            class="editor"
            placeholder="{{ 'mobile' | transloco }} {{
              'description' | transloco
            }}"
            [style]="{ minHeight: '80px' }"
            formControlName="descriptionMobile"
          >
            <ng-template pTemplate="header">
              <app-editor loadData [tenant]="tenant"></app-editor
            ></ng-template>
          </p-editor>
        </div>
      </div>
    </div>
  </form>

  <!-- <div class="w-100 d-flex mt-4">
    <button (click)="onSubmit()" [disabled]="!tenant_form.valid">
      {{ "save" | transloco }}
    </button>
  </div> -->
</div>
